<template>
  <div>
    <basehead />
    <div>
      <IrealViewer
        v-if="parseInt($route.params.identifier)"
        :emb="integration"
        :identifier="list_redirection[$route.params.identifier]"
      ></IrealViewer>
      <IrealViewer
        v-else
        :emb="integration"
        :identifier="$route.params.identifier"
      ></IrealViewer>
      <div class="mr-auto ml-auto mt-2 d-table">
        <!-- <router-link v-show="integration" :to="{ name: 'home'}" class="btn btn-transparent text-uppercase">{{ $t('back') }}</router-link> -->
      </div>
    </div>
  </div>
</template>

<script>
import IrealVue from "ireal-vue";
import basehead from "@/components/basehead.vue";

export default {
  name: "home",
  props: ["emb"],
  metaInfo() {
    return {
      title: "IREAL - Innovative Remote Experimentation for Active Learning",
      meta: [
        {
          name: "description",
          content:
            "Setup scientic experiments from anywhere, at anytime, on your own preferred digital device, and get realistic experimental results in realtime.",
        },
        {
          property: "og:title",
          content:
            "IREAL - Innovative Remote Experimentation for Active Learning",
        },
        { property: "og:site_name", content: "IREAL" },
        { property: "og:type", content: "website" },
        {
          property: "og:image",
          content:
            "https://ireal-preprod.isae.fr/static/labs/" +
            this.route_id +
            "/" +
            this.route_id +
            "_poster.jpg",
        },
        { name: "robots", content: "index,follow" },
      ],
    };
  },
  data() {
    return {
      integration: true,
      // this temporary redirection is for old production experiments used where the url syntax was the id and not the identifier. To be removed when changes are made by users
      list_redirection: {
        1: "chladni",
        2: "wheel",
        3: "hydraulique",
        4: "canal",
        7: "orifices_et_ajutages",
        9: "conduction",
        10: "thermodynamique",
      },
    };
  },
  components: {
    IrealViewer: IrealVue.IrealViewer,
    basehead,
  },
  async mounted() {
    this.emb != "/emb" ? (this.integration = true) : (this.integration = false);
  },
  computed: {
    route_id() {
      return this.$route.params.identifier;
    },
  },
};
</script>
